module.exports = __webpack_public_path__ + "img/icon-mail.02e393d4.svg";